<template>
  <new-modal-wrapper
    ref="newSizeSelectionModal"
    modal-name="newSizeSelectionModal"
    :click-to-close="false"
    :show-close-icon="false"
    cta-primary-button="sizeSelectionContinue"
    @cta-action="onContinue"
    @closed="resetSelectField"
  >
    <div class="new-size-selection-content">
      <h2 class="text-center new-size-selection-title">{{ translations.sizeSelectionHeader }}</h2>
      <div class="content">
        <div class="CTA-wrapper row">
          <div class="columns small-10 small-offset-1">
            <select
              name="customizer-ugc-main-size"
              data-menu-id="1"
              class="ugc-main-select-size-selector"
              v-show="areSizesLoaded"
              v-model="sizeSelected"
              @change="onSelect()"
            >
              <option value=""> {{ translations.selectText }} </option>
              <option
                v-for="(value, index) in sizes.values"
                :key="value"
                :value="sizes.identifier[index]"
              >
                {{ value }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </new-modal-wrapper>
</template>

<script>
import newModalWrapper from '@/components/Modals/NewModalWrapper/NewModalWrapper';
import sizeSelect from '@/mixins/UGC/sizeSelect';

export default {
  name: "newSizeSelectionModal",
  components: {
    newModalWrapper,
  },
  mixins: [ sizeSelect ],
  data() {
    return {
      disabledCta: true
    };
  },
  computed: {
    translations() {
      return this.$store.state.translations.data;
    },
    sizes() {
      return this.$store.state.utils.audienceSizes;
    },
    areSizesLoaded() {
      return Object.keys(this.sizes).length > 0;
    },
  },
  watch: {
    sizeSelected(newValue) {
      this.$refs.newSizeSelectionModal.blockCtaPrimaryButton(!newValue);
    },
  },
  methods: {
  },
  mounted() {
    this.$refs.newSizeSelectionModal.blockCtaPrimaryButton(!this.sizeSelected);
  },
};
</script>
